import { FactoryTypes, FieldID } from "../../../models";
import { FlowTypes, MobileDeviceValues } from "@trailhead/smart-setup-core";

export const eSIMiPhone14GenericActivation = {
  criteria: { newPhone: MobileDeviceValues.iPhone, newDeviceIsiPhone14: true, newDeviceActivated: false, deviceFlowType: FlowTypes.Replacement },
  criteriaWeight: {
    newDeviceIsiPhone14: 5,
  },
  content: [
    {
        type: FactoryTypes.TIPBOX,
        fieldMapping: {
          text: FieldID.guideContainer.tipBox.iPhone14ActivationTipBox,
          heading: FieldID.guideContainer.tipBox.iPhone14ActivationTipBox,
        },
    },
    {
        type: FactoryTypes.NUMBERED_STEP,
        fieldMapping: {
            text: FieldID.guideContainer.steps.iphone14ActivationIMEI.text,
            substep: FieldID.guideContainer.steps.iphone14ActivationIMEI.substep,
        }
    },
    {
        type: FactoryTypes.NUMBERED_STEP,
        fieldMapping: {
            text: FieldID.guideContainer.steps.iPhone14ActivationCallNumber.text,
            substep: FieldID.guideContainer.steps.iPhone14ActivationCallNumber.substep,
        }
    }
]};
